import { ReactNode } from "react"

import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { queryClient } from "../services/queryClient";
import { persistOptions } from "../services/queryPersist";
import { ApiClientProvider } from "./ApiContext";
import { AuthProvider } from "./AuthContext";
import { UIProvider } from "./UIContext";



type Props = {
  children: ReactNode;
}

function Providers({
  children
}: Props) {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <AuthProvider>
        <UIProvider>
          <ApiClientProvider>
            {children}
          </ApiClientProvider>
        </UIProvider>
      </AuthProvider>
      {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </PersistQueryClientProvider>
  );
}

export default Providers;
